export const getNestedValue = (fieldName, dataItem) => {
  const path = fieldName.split(".");
  let data = dataItem;
  path.forEach((p) => {
    data = data ? data[p] : undefined;
  });
  return data;
};

export const formatNumberWithCommas = (value) => {
  const parsed = parseInt(value, 10);
  if (isNaN(parsed)) return value;
  return parsed.toLocaleString();
};

export const formatDateTimeShort = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "Invalid Date";

  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true
  }).format(date);
};

export const formatDate = (dateValue) => {
  if (!dateValue) return null;

  let date = dateValue instanceof Date ? dateValue : new Date(dateValue);
  if (isNaN(date.getTime())) return null;

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
};

export const toFuzzyTime = (dateInput) => {
  if (!dateInput) return "";

  const now = new Date();
  const then = new Date(dateInput);

  if (isNaN(then.getTime())) return "";

  const seconds = Math.floor((now - then) / 1000);

  const MINUTE = 60;
  const HOUR = 60 * MINUTE;
  const DAY = 24 * HOUR;
  const WEEK = 7 * DAY;
  const MONTH = 30 * DAY;
  const YEAR = 365 * DAY;

  if (seconds < 5) return "Just now";
  if (seconds < 60) return "Seconds ago";
  if (seconds < 90) return "A minute ago";
  if (seconds < HOUR) return `${Math.floor(seconds / MINUTE)} mins ago`;
  if (seconds < HOUR * 1.5) return "An hour ago";
  if (seconds < DAY) return `${Math.floor(seconds / HOUR)} hrs ago`;
  if (seconds < DAY * 2) return "Yesterday";
  if (seconds < WEEK) return `${Math.floor(seconds / DAY)} days ago`;
  if (seconds < WEEK * 2) return "Last week";
  if (seconds < MONTH) return `${Math.floor(seconds / WEEK)} weeks ago`;
  if (seconds < MONTH * 2) return "Last month";
  if (seconds < YEAR) return `${Math.floor(seconds / MONTH)} months ago`;
  if (seconds < YEAR * 2) return "Last year";

  return `${Math.floor(seconds / YEAR)} years ago`;
};

// Seconds as "45s", "12m", "3h 20m" or "2d 4h". Null, non-numeric and negative values print "—":
// a negative duration comes from timestamp maths upstream, and printing it reads as a bug here.
// Same output as the copies in LockDeskQueue.vue and RevenueAnalysis.vue.
export const formatDuration = (seconds) => {
  const parsed = typeof seconds === "number" ? seconds : parseFloat(seconds);
  if (!Number.isFinite(parsed) || parsed < 0) return "—";

  if (parsed < 60) return `${Math.round(parsed)}s`;

  const minutes = Math.floor(parsed / 60);
  if (minutes < 60) return `${minutes}m`;

  const hours = Math.floor(minutes / 60);
  const restMinutes = minutes % 60;
  if (hours < 24) return restMinutes ? `${hours}h ${restMinutes}m` : `${hours}h`;

  const days = Math.floor(hours / 24);
  const restHours = hours % 24;
  return restHours ? `${days}d ${restHours}h` : `${days}d`;
};

export const isToday = (dateString) => {
  const today = new Date();
  const inputDate = new Date(dateString);

  return (
    inputDate.getDate() === today.getDate() &&
    inputDate.getMonth() === today.getMonth() &&
    inputDate.getFullYear() === today.getFullYear()
  );
};

export const isPastDue = (dateString) => {
  const inputDate = new Date(dateString);
  const currentDate = new Date();

  inputDate.setHours(0, 0, 0, 0);
  currentDate.setHours(0, 0, 0, 0);

  return inputDate < currentDate;
};

export const isTaskPastDue = (dateValue) => {
  if (!dateValue) {
    return false;
  }

  const inputDate =
    dateValue instanceof Date
      ? new Date(dateValue)
      : new Date(dateValue);

  if (Number.isNaN(inputDate.getTime())) {
    return false;
  }

  const currentDate = new Date();

  inputDate.setHours(0, 0, 0, 0);
  currentDate.setHours(0, 0, 0, 0);

  return inputDate < currentDate;
};
